export default "__VITE_ASSET__DkZXosBt__"